export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скинути"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вибрати все"])}
}